var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageLayout',{attrs:{"x-large-width":""}},[_c('div',{staticClass:"container"},[_c('Trading'),_c('DashboardBalance'),_c('div',{staticClass:"row"},[_c('PersonalDetails'),_c('PartnerProgram')],1)],1),_c('Spacer',{attrs:{"height":"","size":"m"}}),_c('Marketing')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }